module.exports = __webpack_public_path__ + "img/cap-30.094f96ba.png";